export const DOMESTIC_ID = '225';
export const UK_ID = '224';
